// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2xQ49","footer":"ModalUpdate_footer__SaEyp"};